/**
 * Create the accordeon open tracking object
 * @param {object} trackingData - Tracking Data
 */
import {
    TRACKING_ACCORDEON_INTERACTION_TYPE,
    TRACKING_ACCORDEON_ELEMENT_NAME,
} from 'Container/Tracking/constant';

/**
 * Creates Tracking Payload for Accordeon-Click-Event
 * @param offerId
 */
export const createTrackingAccordionOpen = (offerId: string) => {

    const trackingPayload = {
        interactionType: TRACKING_ACCORDEON_INTERACTION_TYPE,
        elementName: TRACKING_ACCORDEON_ELEMENT_NAME,
        location: offerId,
    };

    return trackingPayload;
};
